export default __webpack_public_path__ + "static/media/ico_home.730df982.svg";